interface ConditionalProps {
  condition: boolean;
}

const Conditional: React.FC<React.PropsWithChildren<ConditionalProps>> = ({
  condition,
  children,
}) => {
  return condition ? children : null;
};

export default Conditional;
